<template>
  <div
    v-if="shouldShowBanner"
    class="banner">
    <div class="container">
      <v-flex>
        <AnuncioBanner />
      </v-flex>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ANUNCIO } from '../../utils/types'
import AnuncioBanner from './AnuncioBanner.vue';

export default {
  name: 'Banner',

  components: {
    AnuncioBanner
  },
  
  data: () => ({
    exibeAnuncio: false
  }),

  computed: {
    ...mapState('app', [
      'user', 
      'empresa', 
      'acesso_premium'
    ]),
    
    shouldShowBanner() {
      return this.exibeAnuncio
    }
  },

  mounted() {
    this.checkBannerVisibility()
  },

  methods: {
    checkBannerVisibility() {
      if (this.user) {
        this.exibeAnuncio = this.getAcessoModulo({ 
          user: this.user, 
          modulo: ANUNCIO 
        })
      }
    }
  }
}
</script>